import { ADMIN_PREFERENCE_CACHE_KEYS } from '@/shared/constants/cache-keys'

export const DEFAULT_ADMIN_TENANT_CODE = '10000'

interface TenantStorage {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
}

const browserStorage = (): TenantStorage | undefined => {
  return typeof localStorage === 'undefined' ? undefined : localStorage
}

export const normalizeAdminTenantCode = (value: unknown): string => {
  const code = String(value ?? '').trim()
  return /^[1-9]\d*$/.test(code) ? code : DEFAULT_ADMIN_TENANT_CODE
}

export const readAdminTenantCode = (
  storage: TenantStorage | undefined = browserStorage()
): string => normalizeAdminTenantCode(storage?.getItem(ADMIN_PREFERENCE_CACHE_KEYS.tenantCode))

export const writeAdminTenantCode = (
  value: unknown,
  storage: TenantStorage | undefined = browserStorage()
): string => {
  const code = normalizeAdminTenantCode(value)
  storage?.setItem(ADMIN_PREFERENCE_CACHE_KEYS.tenantCode, code)
  return code
}
